// extracted by mini-css-extract-plugin
export default {"menu":"Administration_menu__TbCnC","collapsed":"Administration_collapsed__Q6mD0"};